var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCloudSecondary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1434_7449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0041 11.496H12.3797C14.0988 11.496 15.5053 10.583 15.5053 8.8829C15.5053 7.18284 13.8487 6.3364 12.5047 6.26983C12.2268 3.61112 10.2855 1.9939 8.00371 1.9939C5.84699 1.9939 4.45794 3.42515 4.00284 4.84452C2.12743 5.02268 0.502075 6.21607 0.502075 8.17024C0.502075 10.1244 2.18994 11.496 4.25289 11.496H6.00327",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.005 7.99559L8.00426 5.99487L6.00354 7.99559",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00439 14.0096V6.49487",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1434_7449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.0035,
    height: 16.0035,
    fill: "white",
    transform: "translate(0.00250244)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloudSecondary);
export default __webpack_public_path__ + "static/media/ic-cloud-secondary.b8ee275a875abf93c9fff8be485eedc8.svg";
export { ForwardRef as ReactComponent };